import { useEffect } from 'react';

import { GigyaAPI } from '@ciam/gigya-api';
import { useLoginInfoStore } from '@features/shared';
import { useValidatorStore } from '@features/proxy';

import type { UserInfo } from '@features/shared';

export const LoginInfoCheck = () => {
  const setUserInfo = useLoginInfoStore((state) => state.setUserInfo);
  const { setValidateStep } = useValidatorStore();

  useEffect(() => {
    const fetchAccountInfo = async () => {
      try {
        const accountInfo = (await GigyaAPI.accounts.getAccountInfo()) as UserInfo;
        setUserInfo(accountInfo);
        setValidateStep('password-check');
      } catch (err) {
        console.error('Failed to fetch account info:', err);
      }
    };

    fetchAccountInfo();
  }, [setUserInfo, setValidateStep]);

  return null;
};
